import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BcComponentsService, DetailBcinfos } from '../bc-components.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { Title } from '@angular/platform-browser';
import { CycleBcModel } from 'src/app/shared/models/societe-linked/bc/cycle-bc.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { InfoLettrageComponent } from '../modals/info-lettrage/info-lettrage.component';
import { ModalCycleValidationComponent } from '../modals/modal-cycle-validation/modal-cycle-validation.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { UserModelDTO } from 'src/app/shared/dtos/userModelDTO';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { ModalEnvoyeRelance } from 'src/app/shared/components/modals/modal-envoye-relance/modal-envoye-relance.component';
import { MailService } from 'src/app/shared/services/mailService';
import { error } from 'console';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { ModalFormulaireEmailComponent } from '../modals/modal-formulaire-email/modal-formulaire-email.component';
import { filter, first } from 'rxjs/operators';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { DefinitionDroitsBC } from 'src/app/shared/droitsDefinitions';

@Component({
  selector: 'app-read-bc',
  templateUrl: './read-bc.component.html',
  styleUrls: ['./read-bc.component.scss']
})
export class ReadBcComponent implements OnInit, OnDestroy  {
  bcForm: UntypedFormGroup;
  bc: BcModel = new BcModel();
  idBc: number;
  detailBcInfo: DetailBcinfos;
  bcLineHTs = 0;
  bcLineTVAs = 0;
  bcLineTTCs = 0;
  childHeight: number = 0;
  parentWidth: number = 0;
  canRelance = false;
  user: UtilisateurModel;

  constructor(private bcService: BcService,
              private router: Router,
              private bcComponentsService: BcComponentsService,
              private sessionService: SessionService,
              private route: ActivatedRoute,
              private toastrService: ToastrService,
              private title: Title,
              private societeService: SocieteService,
              public dialog: MatDialog,
              private mailService: MailService
) {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.bcService.bcSubscriber.subscribe((bc: BcModel) => {
          if (bc !== null) {
            this.bc = Object.assign({}, bc);
          } else {
            this.toastrService.error('Erreur durant la récupération du bon de commande.', 'Erreur');
            this.router.navigate(['/']);
          }
        });
      } else {
        this.bcService.get(params.id).subscribe(bc => {
          this.bc = bc;
          this.title.setTitle('SACHA - Voir BC ' + ( bc.fValide === NTHFlag.All ? bc.code : "Cxxxxxxxxxx"));
          this.detailBcInfo = new DetailBcinfos();
          this.bcLineHTs = bc.ht;
          this.bcLineTVAs = bc.tva;
          this.bcLineTTCs = bc.ttc;
          this.bcForm = this.bcComponentsService.getVisualizeBcFormGroup(this.bc);
          this.societeService.get(this.bc.idSociete).subscribe((res) => this.bc.societe = res);
          this.sessionService.currentUser.subscribe(user => {
            this.user = user;
            const isAdmin = this.user.droits.filter(droit =>
              (droit.niveau === DefinitionDroitsBC.CREER) &&
              (droit.type.toUpperCase() === 'ADMIN') &&
              (droit.idSociete === this.bc.societe.id)
            );
            if (isAdmin.length > 0 || user.id == this.bc.idCreateur) {
              this.canRelance = true;
            }
          });
        }, (error) => {
          toastrService.error('Le bon de commade n\'existe pas');
          this.router.navigate(['/not-found']);
        });
      }

    });
  }

  ngOnInit(): void {
    this.getChildHeight();
    this.getParentWidth();
  }
  close(): void {
    this.router.navigate(['/list-bc/']);
  }
  ngOnDestroy(): void {
    this.bcComponentsService.purgeDetailBcInfo();
  }
  lettrageBpInfo(): void {
    const dialogConfirmation = this.dialog.open(InfoLettrageComponent, {
      data: {
        message: 'Info Lettrage',
        form: this.bcForm
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
    });
  }

  getChildHeight(): any {
    setTimeout(() => {
      const childHeight = document.querySelector('#heigthChild')?.clientHeight;
      if (childHeight && childHeight > 0) {
        this.childHeight = childHeight;
      }
    }, 200);
  }

  getParentWidth(): any {
    setTimeout(() => {
      const parentWidth = document.querySelector('#parent-container')?.clientWidth;
      if (parentWidth && parentWidth > 0) {
        this.parentWidth = parentWidth;
      }
    }, 200);
  }
  
  openCycleValidation() {
    const dialog = this.dialog.open(ModalCycleValidationComponent, {
      data: {
        idBc: this.bc.id,
        idSociete: this.bc.idSociete,
        codeCa1: this.bcForm.get('codeCa1').value
      }
    });
  }

  openRelance() {
    this.dialog.open(ModalEnvoyeRelance, {
      restoreFocus: false,
      data: {
        icone: "",
        title: "",
        message: "Qui souhaitez-vous relancer ?",
        color: "primary",
        iconColor: "",
        dialogWidth: "",
        dialogHeight: ""
      }
    }).afterClosed().subscribe(res => {
      switch (res) {
        case 'Valideur':
          const dialogRefVal = this.dialog.open(SpinnerModalComponent);
          this.mailService.sendValidateurs(this.bc).subscribe(res => {
            if (res) {
              this.toastrService.success("Les emails ont bien été envoyés aux validateurs");
            }
            dialogRefVal.close();
          }, error => {
            dialogRefVal.close();
            this.toastrService.error("Erreur lors de l’envoi des emails aux validateurs");
          });
          break;
        case 'Deleg':
          const dialogRefDeleg = this.dialog.open(SpinnerModalComponent);
          this.mailService.sendDelegs(this.bc).subscribe(res => {
            if (res) {
              this.toastrService.success("Les emails ont bien été envoyés aux délégataires");
            }
            dialogRefDeleg.close();
          }, error => {
            dialogRefDeleg.close();
            this.toastrService.error("Erreur lors de l’envoi des emails aux délégataires");
          });
          break;
        default:
          break;
      }
    });
  }

  sendEmail() {
    this.sessionService.addScope("https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.settings.basic https://www.googleapis.com/auth/gmail.send");
    this.sessionService.userResponseSubject.pipe(filter(user => {
      return this.sessionService.containsAskedScope();
    }), first()).subscribe((user) => {
      const dialogConfirmation = this.dialog.open(ModalFormulaireEmailComponent, {
        disableClose: true,
        autoFocus: false,
        width: '70%',
        maxHeight: '99vh',
        data: {
          bcForm: this.bcForm,
        }
      });
      dialogConfirmation.afterClosed().subscribe(res => {
      });
    });
  }
}
